"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var i=e=>({root:{color:({color:o})=>o?e.palette.common[o]:e.palette.common.gray600}});exports.default=i;
//# sourceMappingURL=styles.js.map
